import BaseService from './BaseService'

export interface IGlobalSearchPayload {
  companyId: string,
  locationId: string,
  filterBy: [],
}

export interface IGlobalSearchResponse {
  companyId: string,
  locationId: string,
  filterBy: [],
}

class GlobalSearchService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  searchDynamic = (query: string, modules: string[], companyId: string, locationId: string,  page: number = 1, pageLimit: number = 20) =>
    this.requests.post(
      `/dynamic`, {
        q: query,
        modules,
        companyId,
        locationId,
        page,
        limit: pageLimit
      }
    )

  getAllActiveModules = (locationId: string) =>
      this.requests.get(
        `/modules?locationId=${locationId}`
      )
}

const instance = new GlobalSearchService(BaseService.servicesConfig.GlobalSearch ?? "")

export default instance
